<template>
  <div class="row justify-content-center">
    <div class="alert alert-danger mt-4" v-show="showWarning">Invalid login/password</div>
    <form class="v-center" @submit.prevent="submit()" style="width: 300px">
      <img src="qsys-logo.png" alt="" class="img-fluid mx-auto d-block" style="max-width: 300px; margin-bottom: 30px">
      <label for="inputUsername" class="sr-only">Email address</label>
      <input
        v-model="username"
        type="text"
        id="inputUsername"
        class="form-control mb-5"
        placeholder="Username"
        required
        autofocus
        @keydown="showWarning = false"
        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
      />
      <label for="inputPassword" class="sr-only">Password</label>
      <input
        v-model="password"
        type="password"
        id="inputPassword"
        class="form-control mb-5"
        placeholder="Password"
        required
        @keydown="showWarning = false"
        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
      />
      <!-- <div class="checkbox mb-3">
        <label>
          <input type="checkbox" value="remember-me" /> Remember me
        </label>
      </div>-->
      <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
      <!-- <p class="mt-5 mb-3 text-muted">© 2020</p> -->
    </form>
  </div>
</template>

<script>
import { login } from "../lib/auth";

export default {
  data() {
    return {
      username: "",
      password: "",
      showWarning: false,
    };
  },
  methods: {
    submit() {
      login(this.username, this.password)
        .then(user => {
          this.$emit("login", user);
        })
        .catch(() => (this.showWarning = true));
    },
  },
};
</script>

<style scoped>
.v-center {
  position: absolute;
  transform: translateY(-40%);
  top: 40%;
}
</style>